import { ConfigurationPostingFrameService_postingFrameServiceGetValidAccountTypes } from '@festina/life-general-types/life/hooks/ConfigurationPostingFrameService_postingFrameServiceGetValidAccountTypes'

export const useFetchPostingFrameAccountTypes =
  ConfigurationPostingFrameService_postingFrameServiceGetValidAccountTypes.useSuspenseQuery
